@if (fbService.currentSection()) {
  @for (subsection of fbService.currentSection().subSections; track subsection.id; let i = $index) {
    <div class="fb-sub-item" [class.fb-sub-item--active]="highlightedId() === subsection.id"
         (click)="emitSelection(fbService.currentSection(), subsection, null, 'section')">
      <span class="uk-text-truncate">
        <span class="uk-text-muted">{{ String.fromCharCode(65 + chapterIndex()) }}{{ i + 1 }}</span>
        {{ subsection.name?.trim() || 'Untitled section ' + (i + 1) }}
      </span>
      <span class="uk-flex uk-flex-middle">
        <span class="fb-sub-count">{{ subsection.fields?.length ?? 0 }}</span>
        <span class="material-icons uk-cursor-pointer uk-margin-small-left" style="font-size: 16px;"
              (click)="$event.stopPropagation(); deleteSubSection(chapterIndex(), i)">delete</span>
      </span>
    </div>
  }

  <button class="uk-button uk-button-default uk-button-small uk-width-1-1 uk-margin-small-top"
          type="button" (click)="addSubSection(chapterIndex())">
    <span class="material-icons" style="font-size: 16px; vertical-align: middle;">add</span> Add subsection
  </button>
}
